import React from 'react';

type IconProps = {
  size?: number; // Size of the icon
  className?: string; // Additional custom classes
};

const GiftIcon: React.FC<IconProps> = ({ size = 22, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3333 7.3335H3.66667C3.16067 7.3335 2.75 7.74416 2.75 8.25016V10.0835C2.75 10.5895 3.16067 11.0002 3.66667 11.0002H18.3333C18.8393 11.0002 19.25 10.5895 19.25 10.0835V8.25016C19.25 7.74416 18.8393 7.3335 18.3333 7.3335Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9998 19.2502V7.3335"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3881 6.06104C13.3999 7.08954 11.8443 7.33337 11.0908 7.33337"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0909 7.33336C11.0909 7.33336 10.6381 4.47703 11.7518 3.31836"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3883 6.06103C15.1162 5.30386 15.1162 4.07553 14.3883 3.31836C13.6605 2.5612 12.4808 2.5612 11.7529 3.31836"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.6123 6.06104C8.60047 7.08954 10.1561 7.33337 10.9096 7.33337"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9093 7.33336C10.9093 7.33336 11.3621 4.47703 10.2484 3.31836"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.61228 6.06103C6.88445 5.30386 6.88445 4.07553 7.61228 3.31836C8.34011 2.5612 9.51986 2.5612 10.2477 3.31836"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4168 11V18.3333C17.4168 18.8393 17.0062 19.25 16.5002 19.25H5.50016C4.99416 19.25 4.5835 18.8393 4.5835 18.3333V11"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GiftIcon;
